import { render, staticRenderFns } from "./CochlSetting.vue?vue&type=template&id=2a58415e&scoped=true"
import script from "./CochlSetting.vue?vue&type=script&lang=js"
export * from "./CochlSetting.vue?vue&type=script&lang=js"
import style0 from "./CochlSetting.vue?vue&type=style&index=0&id=2a58415e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58415e",
  null
  
)

export default component.exports